<template>
	<div class="page-edit-property">
		<ValidationObserver ref="propertyForm">
			<form @submit.prevent>
				<div class="admin-property">
					<div class="admin-single-property__breadcrumbs">
						<div class="admin-single-property__breadcrumbs-wrap">
							<span class="section-title section-title--breadcrumbs">{{ edit ? property.title : 'Create New Property' }}</span>
						</div>
						<div class="notification-wrap-center" v-if="notificationsData.msg" >
							<PartNotifications :data="notificationsData"/>
						</div>

						<div class="notification-wrap-center" v-if="notificationsExistData.msg" >
							<PartNotifications @closeNotificaiton="closeNotificaitonExist" :data="notificationsExistData"/>
						</div>

						<div class="breadcrumbs__button">
							<button class="btn breadcrumbs__button-btn" id="save_property-button" :class="{'btn--disabled': btnIsDisabled}" :disabled="btnIsDisabled" @click="addNewAndEditProperty">
								<SvgIcon class="save-icon" iconName="ico-save"/>
								<span>Save</span>
							</button>
							<a class="btn btn--white btn--cancel breadcrumbs__button-btn" id="cancel_property-button" @click="cancelProperty">
								Cancel
							</a>
						</div>
					</div>
					<!-- TODO: POST MVP -->
<!--					<div class="container-fluid admin-property__switch-container">-->
<!--						<div class="admin-property__switch-wrap">-->
<!--							<div class="admin-property__switch" :class="{'is-active': isResidential()}" @click="setCategory(1)">-->
<!--								<a id="residential-button">Residential</a>-->
<!--							</div>-->
<!--							<div class="admin-property__switch" :class="{'is-active': !isResidential()}" @click="setCategory(2)">-->
<!--								<a id="commercial-button">Commercial</a>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
				<div class="error-messages__list" v-if="errors.length">
					<span class="error-messages__title">
						<SvgIcon class="error-messages__icon error-messages__icon--exclamation" iconName="ico-exclamation-circle"/>
						Please fill in all required fields:
					</span>
					<ul>
						<li class="error-messages__item" v-for="error in errors" :key="error">{{ error }}</li>
					</ul>
				</div>
					<div class="admin-property__content">
						<div class="container-fluid">
							<div class="row">
								<div class="col-lg-6">
									<span class="property-form__input-title">Address</span>
									<div class="admin-property__map">
										<!-- Map -->
										<BlockMapInput :data="DataMapInput" @placeChanged="fillAddress" @resetMap="resetAddress" ref="map"/>
									</div>
								</div>
								<div class="col-lg-6">
									<span class="property-form__input-title">Gallery</span>
									<div class="admin-property__gallery">
										<!-- Gallery Input -->
										<BlockGalleryInput
											v-model="property.gallery"
											ref="gallery_absolute"
											:data="galleryData"
											@deletedImages="deletedImages"
											@uploadImages="uploadImages"
											@setMainImage="setMainImage"
											@deleteMainImage="deleteMainImage"
										/>
									</div>
								</div>
							</div>
							<!-- Single Property Form -->
							<div class="property-form">
								<div class="container-fluid">
									<div class="row">
										<div class="col-lg-6 col-md-6">
											<div class="property-form__wrap">
												<!-- ADMIN NOTE -->
												<span class="property-form__input-title">Admin’s Note</span>
												<div class="property-form__input property-form__input--textarea">
													<PartInputTextarea v-model="property.note" ref="note" :data="DataNewNote"/>
												</div>
												<!-- ADDRESS -->
												<span class="property-form__input-title">Address</span>
												<div class="property-form__input property-form__input--address">
													<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
														<PartInputBasic v-model="property.street_name" :class="classes" ref="street_name" :data="DataStreet"/>
														<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
													</ValidationProvider>
												</div>
												<div class="property-form__input property-form__input--half  property-form__input--half-sm-fields">
													<div class="property-form__input-small">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="property.street_number" :class="classes" ref="street_number" :data="DataStreetNumber"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input-small">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="property.zip" ref="zip" :class="classes" :data="DataPostalCode"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
												</div>
												<div class="property-form__input--half-wrap">
													<div class="property-form__input property-form__input--half">
														<PartInputBasic v-model="property.neighborhood" ref="neighborhood" :data="DataNeighbourhood"/>
													</div>
													<div class="property-form__input property-form__input--half" v-show="!isResidential()">
														<ValidationProvider :rules="`${!isResidential() ? 'required' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="property.state" ref="state" :class="classes" :data="DataState"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
												</div>
												<div class="property-form__input--half-wrap property-form__input--mix-checkbox">
													<div class="property-form__input property-form__input--half">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="property.cross_street" :class="classes" ref="cross_street" :data="DataCrossStreet"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input property-form__input--select-single">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartCheckboxDropdown v-model="property.area"  :class="classes" ref="area" :data="DataArea"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
												</div>
												<!-- FEATURES -->
												<span class="property-form__input-title">Features</span>

												<div class="property-form__input--half-wrap">
													<div class="property-form__input property-form__input--half">
														<PartInputBasic v-model="property.far" ref="far" :data="DataFar"/>
													</div>
													<div class="property-form__input property-form__input--half">
														<PartInputBasic v-model="property.total_buildable" ref="total_buildable" :data="DataTotalBuildable"/>
													</div>
												</div>
												<div class="property-form__input--half-wrap">
													<div class="property-form__input property-form__input--half">
														<PartInputBasic v-model="property.income" ref="income" :data="DataIncome"/>
													</div>
													<div class="property-form__input property-form__input--half">
														<PartInputBasic v-model="property.expenses" ref="expenses" :data="DataExpenses"/>
													</div>
												</div>
												<div class="property-form__input--half-wrap">
													<div class="property-form__input property-form__input--half">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="property.zoning" :class="classes" ref="zoning" :data="DataZoning"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input property-form__input--half">
														<PartInputBasic v-model="property.number_of_floors" ref="number_of_floors" :data="DataNumberOfFloors"/>
													</div>
												</div>
												<div class="property-form__input--half-wrap">
													<div class="property-form__input property-form__input--half" v-show="!isResidential()">
														<PartInputBasic v-model="property.cap_rate" ref="cap_rate" :data="DataCapRate"/>
													</div>
													<div class="property-form__input property-form__input--half">
														<PartInputBasic v-model="property.noi" ref="noi" :data="DataNoi"/>
													</div>
												</div>
												<div class="property-form__input">
													<div class="property-form__input">
														<PartInputBasic v-model="property.layout" ref="layout" :data="DataLayout"/>
													</div>
												</div>
												<div class="property-form__input--half-wrap">
													<div class="property-form__input property-form__input--half" v-show="isResidential()">
														<PartInputBasic v-model="property.garage" ref="garage" :data="DataGarage"/>
													</div>
													<div class="property-form__input property-form__input--half" v-show="isResidential()">
														<PartInputBasic v-model="property.parking" ref="parking" :data="DataParking"/>
													</div>
												</div>
												<div class="property-form__input" v-show="isResidential()">
													<PartInputBasic v-model="property.material" ref="material" :data="DataMaterial"/>
												</div>
												<!-- OWNER -->
												<span class="property-form__input-title">Owner</span>
												<div class="property-form__input">
													<PartSwitch v-model="property.hide_owner" ref="hide_owner" :data="DataOwnerHide"/>
												</div>
												<div class="property-form__input--half-wrap">
													<div class="property-form__input property-form__input--half">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="property.owner_name" :class="classes" ref="owner_name" :data="DataOwnerName"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input property-form__input--half">
														<ValidationProvider :rules="`${haveEmail ? 'email' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="property.owner_email" :class="classes" ref="owner_email" :data="DataOwnerEmail"/>
															<span class="error-message">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
												</div>
												<div class="property-form__input--half-wrap property-form__input--owner">
													<div class="property-form__input property-form__input--half">
														<ValidationProvider rules="required|min:5" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="property.owner_phone" :class="classes" ref="owner_phone" :data="DataOwnerPhone"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input property-form__input--half">
														<ValidationProvider :rules="`${havePhone2 ? 'min:5' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="property.owner_phone_2" :class="classes" ref="owner_phone_2" :data="DataOwnerPhone2"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
												</div>
											</div>
										</div>
										<!-- PROPERTY -->
										<div class="col-lg-6 col-md-6">
											<div class="property-form__wrap">
												<span class="property-form__input-title">Property</span>
												<!-- old iteration of pdfs -->
												<!-- <div class="property-form__input--half-big property-form__input--pdf-big"> -->
													<!-- <div class="property-form__input-half-pdf">
														<div class="property-form__input-pdf-file">
															<div class="property-form__input">
																<span class="input-label">Upload PDF File:</span>
																<div class="property-form__input-upload-file">
																	<div class="upload-btn-wrapper" v-if="!pdf_name.length > 0">
																		<div class="btn btn--pdf btn--pdf--upload">
																			<span class="upload-btn-wrapper-inner">
																				<SvgIcon
																					class="add-pdf-icon"
																					iconName="ico-plus"
																				/>
																				<span>Upload PDF</span>
																			</span>
																		</div>
																		<input @change="uploadPDF" @dragover="dragover" ref="file" type="file" accept=".pdf" name="image"/>
																	</div>
																	<div class="uploaded-file" v-else>
																		<span class="uploaded-file-info">{{ pdf_name }}</span>
																		<span class="remove-file" @click="removeAddedPDF()">
																			<SvgIcon
																				class="remove-pdf-icon"
																				iconName="ico-close-sm"
																			/>
																		</span>
																		<span class="uploaded-file-tooltip" v-if="pdf_name && pdf_name.length > 37">{{ pdf_name }}<span class="arrow-angle"></span></span>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="property-form__input-half-pdf">
														<div class="property-form__pdf-agent">
															<PartSelect v-model="agent_pdf" ref="agent_pdf" :data="DataAgentsPdf"/>
														</div>
													</div>
													<div class="property-form__input-half-pdf property-form__input-half-pdf--btn" :class="{'disable-btn' : !disablePDFBtn()}">
														<a class="btn btn--pdf" @click="addPDF">Add PDF</a>
													</div>
												</div>
												<div class="notification-pdf">
													<PartNotifications :data="notificationsPdfData" v-if="notificationsPdfData.msg" />
												</div> -->
												<!-- <transition name="fade">
													<div class="property-form__pdf-table" v-if="pdfTable">
														<table class="property-form__pdf-table-wrap">
															<thead>
																<tr>
																	<th>PDF File</th>
																	<th>Agent</th>
																	<th class="property-form__pdf-table-icon"></th>
																</tr>
															</thead>
															<tbody>
																<tr v-for="(row, index) in property.propertyPDFs" :key="index">
																	<td v-if="row.agent_id !== '' && row.pdf_name !== '' && row.agent_id !== null">
																		<span>{{row.pdf_name}}</span>
																	</td>
																	<td v-if="row.agent_id !== '' && row.pdf_name !== '' && row.agent_id !== null">
																		<span>{{getAgentName(row.agent_id)}}</span>
																	</td>
																	<td class="property-form__pdf-table-icon property-form__pdf-table-icon--body" v-if="row.agent_id !== '' && row.pdf_name !== '' && row.agent_id !== null">
																		<a @click="removePDF(index)">
																			<SvgIcon class="close-icon" iconName="ico-close-sm"/>
																		</a>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</transition> -->
												<!-- un-personalized flyer -->
												<div v-if="unpersonalizedPDFTableData.length <= 0">
													<ValidationProvider :rules="`${isFlyerPDFFieldValid() ? '' : 'required'}`" v-slot="{ errors, classes, validate }" class="error-message-holder error-message-holder--flyer error-message-holder--block">
														<div class="upload-flyer" :class="classes" v-if="unpersonalizedPDFTableData.length <=0">
															<div class="upload-flyer__input">
																<div class="upload-flyer__wrap-half-pdf">
																	<div class="upload-flyer__wrap-pdf-file">
																		<div class="upload-flyer__wrap">
																			<span class="input-label">Upload Blank Flyer:</span>
																			<div class="upload-flyer__wrap-upload-file">
																				<div class="upload-flyer__holder" v-if="!pdf_flyer_name.length > 0">
																					<div class="btn btn--pdf btn--pdf--upload">
																						<span class="upload-flyer__holder-inner">
																							<SvgIcon
																								class="add-pdf-icon"
																								iconName="ico-plus"
																							/>
																							<span>Upload Flyer</span>
																						</span>
																					</div>
																					<input @change="uploadFlyer($event); validate($event);"
																						@dragover="dragoverFlyer"
																						type="file"
																						accept=".pdf"
																						name="image"/>
																				</div>
																				<div class="uploaded-file" v-else>
																					<span class="uploaded-file-info">{{ pdf_flyer_name }}</span>
																					<span class="remove-file" @click="removeAddedFlyer()">
																						<SvgIcon
																							class="remove-pdf-icon"
																							iconName="ico-close-sm"
																						/>
																					</span>
																					<span class="uploaded-file-tooltip" v-if="pdf_flyer_name && pdf_flyer_name.length > 37">{{ pdf_flyer_name }}<span class="arrow-angle"></span></span>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<div class="notification-pdf">
																<PartNotifications :data="notificationsPdfDataFlyer" v-if="notificationsPdfDataFlyer.msg" />
															</div>
														</div>
														<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
													</ValidationProvider>
												</div>
												<div v-else>
														Flyer PDF:
														<div class="uploaded-file" v-for="(row, index) in unpersonalizedPDFTableData" :key="index">
															<span class="uploaded-file-info">{{ row.pdf_name}}</span>
															<span class="remove-file" @click="removeFlyerPDF(row.id)">
																<SvgIcon
																	class="remove-pdf-icon"
																	iconName="ico-close-sm"
																/>
															</span>
														</div>
													</div>
												<!-- un-personalized flyer /end -->
												<div class="property-form__input--half-wrap-small">
													<div class="property-form__input property-form__input--half">
														<PartSwitch v-model="property.priority" ref="priority" :data="DataPriority"/>
													</div>
													<div class="property-form__input property-form__input--half" v-show="isResidential()">
														<PartSwitch v-model="property.publicize" ref="publicize" :data="DataPublicize"/>
													</div>
												</div>
												<!--<div class="property-form__input" v-show="isResidential()">
													<PartSelect v-model="property.property_sub_type_residential" ref="property_sub_type_residential" :data="DataPropertySubTypeResidential"/>
												</div>
												<div class="property-form__input" v-show="!isResidential()">
													<PartSelect v-model="property.property_sub_type_commercial" ref="property_sub_type_commercial" :data="DataPropertySubTypeCommercial"/>
												</div>-->
												<div class="property-form__input--half-wrap property-form__input--checkbox">
													<div class="property-form__input property-form__input--half-checkboxdrop select-big-input property-form__input--select property-form__input--property-type" v-show="isResidential()">
														<ValidationProvider :rules="`${isResidential() ? 'required' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartCheckboxDropdown v-model="property.property_type_residential" :class="classes" ref="property_type_residential" :data="DataPropertyTypeResidential"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input property-form__input--half-checkboxdrop select-big-input property-form__input--select property-form__input--property-type"  v-show="!isResidential()">
														<ValidationProvider :rules="`${!isResidential() ? 'required' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartCheckboxDropdown v-model="property.property_type_commercial" :class="classes" ref="property_type_commercial" :data="DataPropertyTypeCommercial"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input property-form__input--half-checkboxdrop">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartSelect v-model="property.listing_status" :class="classes" ref="listing_status" :data="DataListingStatus"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
												</div>
												<div class="property-form__input--half-wrap property-form__input--checkbox">
													<div class="property-form__input property-form__input--half-checkboxdrop">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartSelect v-model="property.listing_type" :class="classes" ref="listing_type" :data="DataListingType"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input select-big-input  property-form__input--half-checkboxdrop property-form__input--offering-type">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartCheckboxDropdown v-model="property.offering_type" :class="classes" ref="offering_type" :data="DataOfferingType"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
												</div>
												<div class="property-form__input property-form__input--half-exclusive-expiration">
													<div class="property-form__input property-form__input--half property-form__input--exclusive-expiration-date" v-if="property.listing_type === 'exclusive'">
														<PartCalendar
															@changeVal="changeVal"
															:data="DataExclusiveExpirationDate"
															dateTitle="Exclusive Expiration Date"
															v-model="property.exclusive_expiration_date"
															ref="exclusive_expiration_date"
														/>
													</div>
												</div>
												<div class="property-form__input--half-wrap">
													<div class="property-form__input property-form__input--half" v-if="property.offering_type.includes('sale')">
														<ValidationProvider :rules="`${property.offering_type.includes('sale') ? 'required' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputFormatedNum v-model="property.regular_price" :class="classes" ref="regular_price" :data="DataPrice"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<!--Price Buildable Square Foot-->
													<div class="property-form__input property-form__input--half" v-if="contains(property.property_type_commercial, ['land', 'commercial-development', 'residential-development'])">
														<PartInputFormatedNum v-model="property.price_buildable_sf" ref="price_buildable_sf" :data="DataPriceBuildableSquareFoot"/>
													</div>
												</div>
												<div class="property-form__input--half-wrap">
													<!--Price Square Foot-->
													<div class="property-form__input property-form__input--half" v-if="contains(property.property_type_commercial, ['industrial', 'warehouse-distribution'])">
														<PartInputFormatedNum v-model="property.price_psf" ref="price_psf" :data="DataPriceSquareFoot"/>
													</div>
													<div class="property-form__input property-form__input--half" v-if="property.offering_type.includes('lease')">
														<ValidationProvider :rules="`${property.offering_type.includes('lease')|| DataSizeBuilding.mandatoryField ? 'required' : ''}`" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputFormatedNum v-model="property.lease_price" :class="classes" ref="lease_price" :data="DataLeasePrice"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
												</div>
													<div class="property-form__input--mix">
														<!--Price Buildable Square Foot-->
														<div class="property-form__input property-form__input--mix-input property-form__input--yearly" v-if="property.offering_type.includes('lease')">
															<PartSwitch v-model="property.show_yearly_price" ref="show_yearly_price" :data="DataYearlyRent"/>
														</div>
														<div class="property-form__input property-form__input--mix-input" v-if="property.offering_type.includes('lease')">
															<div class="property-form__input-lease-notification">
																<span class="property-form__input-notificaation-suc">
																	Yearly Price per Square Foot: <span>{{ getCalculateYPPSF }}</span>
																</span>
																<!-- <span class="property-form__input-notificaation-error" style="display: block; width: 100%;" v-show="!haveYPPSF">Enter Building Size and Lease Price!</span> -->
															</div>
														</div>
													</div>
												<div class="property-form__input--half-date">
													<div class="property-form__input property-form__input--half">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartCalendar
																@changeVal="changeVal"
																:data="DataDateListed"
																dateTitle="Date Listed"
																v-model="property.date_listed"
																ref="date_listed"
																:class="classes"
															/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input property-form__input--half">
														<PartCalendar
															@changeVal="changeVal"
															:data="DataDateVerified"
															dateTitle="Date Verified"
															v-model="property.date_verified"
															ref="date_verified"
														/>
													</div>
												</div>
												<div class="property-form__input property-form__input--agent" ref="Agent" >
													<div class="new-agent property-form__input__new-agent">
														<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartSelect v-model="property.agent" :class="classes" ref="agent" :data="DataAgent"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input-btn-new-agent btn-special">
														<a class="btn btn--icon" id="new-agent-popup-link" @click="showPopup">
															<SvgIcon class="property-form-agents__icon" iconName="ico-plus"/>
															<span>Add New</span>
														</a>
													</div>
												</div>
												<div class="property-form__input">
													<PartInputBasic v-model="property.property_shark_link" ref="property_shark_link" :data="DataPropertyShark"/>
												</div>
												<div class="property-form__input">
													<PartInputBasic v-model="property.lead_source" ref="lead_source" :data="DataSource"/>
												</div>
												<div class="property-form__input property-form__input--decoration">
													<ValidationProvider rules="required" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
														<PartInputTextarea v-model="property.description" :class="classes" ref="description" :data="DataDescription"/>
														<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
													</ValidationProvider>
												</div>
												<!-- BUILDING -->
												<span class="property-form__input-title">Building</span>
												<div class="property-form__input">
													<PartInputBasic v-model="property.building_group_label" ref="building_group_label" :data="DataBuildingGroupLabel"/>
												</div>
												<div class="property-form__input">
													<PartSwitch v-model="property.building_irregular" ref="building_irregular" :data="DataBuildingIrregular"/>
												</div>
												<div class="property-form__input--half-big">
													<div class="property-form__input-half-sm">
														<ValidationProvider :rules="checkBuildingSize" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputFormatedNum v-model="property.building_size" :class="classes" ref="building_size" :data="DataSizeBuilding"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input-half-sm">
														<PartInputFormatedNum v-model="property.building_width" ref="building_width" :data="DataBuildingWidth"/>
													</div>
													<div class="property-form__input-half-sm">
														<PartInputFormatedNum v-model="property.building_length" ref="building_length" :data="DataBuildingLength"/>
													</div>
												</div>
												<div class="property-form__input">
													<PartInputTextarea v-model="property.building_note" ref="building_note" :data="DataBuildingNote"/>
												</div>
												<!-- LOT -->
												<span class="property-form__input-title">Lot</span>
												<div class="property-form__input">
													<PartSwitch v-model="property.lot_irregular" ref="lot_irregular" :data="DataLotIrregular"/>
												</div>
												<div class="property-form__input--half-big">
													<div class="property-form__input-half-sm">
														<ValidationProvider :rules="checkLotSize" v-slot="{ errors, classes }" class="error-message-holder error-message-holder--block">
															<PartInputFormatedNum v-model="property.lot_size" :class="classes" ref="lot_size" :data="DataSizeLot"/>
															<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
													<div class="property-form__input-half-sm">
														<PartInputFormatedNum v-model="property.lot_width" ref="lot_width" :data="DataLotWidth"/>
													</div>
													<div class="property-form__input-half-sm">
														<PartInputFormatedNum v-model="property.lot_length" ref="lot_length" :data="DataLotLength"/>
													</div>
												</div>
												<div class="property-form__input">
													<PartInputTextarea v-model="property.lot_note" ref="lot_note" :data="DataLotNote"/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
			<div class="popup__new-agent" v-if="showModal">
				<div class="popup__wrap" v-on-click-outside="closePopup">
					<vue-simplebar>
						<BlockEditAgent
							:data="DataNewAgentPopup"
							@closePopup="closePopup"
							@setAgent="setAgent"
						/>
						<a class="popup__close" @click="closePopup">
							<SvgIcon class="save-icon" iconName="ico-close-sm"/>
						</a>
					</vue-simplebar>
				</div>
			</div>
			<PartPopupDelete
				v-if="showPopupLeavePage"
				:data="PopupLeavePage"
				@confirmPopupDelete="confirmPopupLeave"
				@closePopupDelete="closePopupLeave"
			>
				<template v-slot:popupTitle>Are you sure you want to leave without saving your changes?</template>
				<template v-slot:popupCancel>No</template>
				<template v-slot:popupConfirm>Yes</template>
			</PartPopupDelete>
			<PartPopupDelete
				v-if="showPopupDelete"
				:data="PopupDelete"
				@confirmPopupDelete="confirmPopupDelete"
				@closePopupDelete="closePopupDelete"
			>
				<template v-slot:popupTitle>Are you sure you want to delete this row from history?</template>
				<template v-slot:popupCancel>No</template>
				<template v-slot:popupConfirm>Yes</template>
			</PartPopupDelete>
		</ValidationObserver>
		<!--<BlockFloorRepeater :data="DataFloor"/>-->

		<div class="container-fluid" v-if="edit && haveHistory">
			<span class="history__title section-title">Property History:</span>
			<span class="history__title history__title--date section-subtitle">
				Date Listed: {{ changeDateFormat(property.created_at) }}
			</span>
			<BlockTable
				class="history__table"
				:data="propertyHistory"
				@deleteHistoryRow="deleteHistoryRow"
			/>
		</div>
		<div class="container-fluid container-fluid--bottom-btn">
			<div class="property-form__bottom-button">
				<a class="btn property-form__bottom-btn" id="save_property-button-bottom" :class="{'btn--disabled': btnIsDisabled}" :disabled="btnIsDisabled" @click="addNewAndEditProperty">
					<SvgIcon class="save-icon" iconName="ico-save"/>
					<span>Save</span>
				</a>
				<a class="btn btn--white property-form__bottom-btn btn--cancel" id="cancel_property-button-bottom" @click="cancelProperty">
					Cancel
				</a>
			</div>
		</div>
		<PartLoaderBig v-if="pageLoader"/>
	</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules';
import { formatDate, toBase64 } from '@/config/util';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import BlockMapInput from '@/components/blocks/BlockMapInput';
import PartInputBasic from '@/components/parts/PartInputBasic';
import BlockGalleryInput from '@/components/blocks/Admin/Properties/BlockGalleryInput';
import PartInputTextarea from '@/components/parts/PartInputTextarea';
import PartSelect from '@/components/parts/PartSelect';
import PartCalendar from '@/components/parts/PartCalendar';
import PartNotifications from '@/components/parts/PartNotifications';
import BlockEditAgent from '@/components/blocks/Admin/Agents/BlockEditAgent';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import PartPopupDelete from '@/components/parts/PartPopupDelete';
import PartSwitch from '@/components/parts/PartSwitch';
import BlockTable from '@/components/blocks/BlockTable';
import PartCheckboxDropdown from '@/components/parts/PartCheckboxDropdown';
import { VueSimplebar } from 'vue-simplebar';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import PartInputFormatedNum from '@/components/parts/PartInputFormatedNum';
// import BlockFloorRepeater from '@/components/blocks/BlockFloorRepeater';

extend('email', {
	...required,
	message: 'This field is mandatory.'
});

extend('email', {
	...email,
	message: 'Email must be in correct format.'
});

extend('required', {
	...required,
	message: 'This field is mandatory.'
});

extend('min', {
	...min,
	message: 'Minimum number of characters is 5.'
});

export default {
	props: {
		edit: Boolean
	},
	data() {
		return {
			pdf_flyer_name: '',
			notificationsPdfDataFlyer: {
				type: '',
				msg: ''
			},
			DataFloor: {},
			pdfTable: false,
			unpersonalizedPDFTableData: [],
			skipUploadingUnpersonaliedPDF: false,
			errors: [],
			developmentChecked: true,
			pageLoader: false,
			showModal: false,
			mapInput: '',
			havePhone2: false,
			haveEmail: false,
			cancelDraft: false,
			cancelPopupPublish: false,
			cloneEdited: false,
			buildingSizeRequired: '',
			DataNewAgentPopup: {
				popupIcon: 'ico-close-sm',
				noAgentPage: true
			},
			activeAddress: false,
			notificationsData: {
				type: '',
				msg: ''
			},
			notificationsPdfData: {
				type: '',
				msg: ''
			},
			notificationsExistData: {
				type: '',
				msg: '',
				hasCloseIcon: true
			},
			showPopupLeavePage: false,
			btnIsDisabled: false,
			property: {
				// General
				id: this.edit ? this.$route.params.id : 0,
				category: 2,
				title: '',
				regular_price: '',
				price_buildable_sf: '',
				price_psf: '',
				property_shark_link: '',
				lead_source: '',
				lease_price: '',
				show_yearly_price: false,
				yearly_price: '',
				agent: '',
				description: '',
				priority: false,
				publicize: false,
				map: {
					location: {
						lat: '',
						lng: ''
					}
				},
				street_name: '',
				street_number: '',
				zip: '',
				neighborhood: '',
				state: '',
				cross_street: '',
				area: '',
				gallery: [], // upload new photos, base64
				gallery_absolute: [], // read only for show photos
				deleted_images: [], // deleted photos from server
				main_image: [], // main image
				main_image_absolute: '', // main image url
				delete_main_image: false, // delete main image
				note: '',
				// main_pdf: '',
				propertyPDFs: [],
				pdfFlyer: '',
				deletedPDFs: [],
				status: 1,

				// Detail
				offering_type: [],
				property_type_residential: [],
				property_type_commercial: [],
				// property_sub_type_residential: '',
				// property_sub_type_commercial: '',
				listing_status: '',
				listing_type: '',
				exclusive_expiration: false,
				exclusive_expiration_date: '',
				date_listed: this.edit ? '' : new Date(Date.now()),
				date_verified: '',
				lot_size: '',
				lot_irregular: false,
				lot_width: '',
				lot_length: '',
				lot_note: '',
				building_group_label: '',
				building_size: '',
				building_irregular: false,
				building_width: '',
				building_length: '',
				building_note: '',

				// Features
				zoning: '',
				far: '',
				total_buildable: '',
				income: '',
				expenses: '',
				noi: '',
				cap_rate: '',
				number_of_floors: '',
				layout: '',
				floors: {
					flor1: {
						room1: 'living room'
					}
				},
				garage: '',
				parking: '',
				material: '',

				// Owner
				owner_name: '',
				owner_email: '',
				owner_phone: '',
				owner_phone_2: '',
				hide_owner: false,

				// Other
				internal_note: '',
				synopsis: 12
			},
			helperProperty: {},
			galleryData: {
				edit: this.edit
			},
			DataPropertyShark: {
				label: 'Property Shark Link',
				placeholder: 'Property Shark Link',
				inputId: 'property_shark_link-input',
				labelId: 'property_shark_link-label',
				mandatoryFiled: false
			},
			DataSource: {
				label: 'Source',
				placeholder: 'Source',
				inputId: 'lead_source-input',
				labelId: 'lead_source-label',
				mandatoryFiled: false
			},
			DataMapInput: {
				type: 'text',
				placeholder: 'Type in address',
				inputId: 'map_search-input'
			},
			DataPropertyName: {
				labelClass: 'admin-property__content-property-label',
				label: 'Property Name',
				placeholder: 'Property Name',
				inputId: 'title-input',
				labelId: 'title-label',
				mandatoryFiled: false
			},
			DataSizeBuilding: {
				label: 'Size',
				type: 'number',
				placeholder: 'Enter Size',
				inputId: 'building_size-input',
				labelId: 'building_size-label',
				mandatoryFiled: false
			},
			DataBuildingGroupLabel: {
				label: 'Building Group Label',
				placeholder: 'Building Group Label',
				inputId: 'building_group_label-input',
				labelId: 'building_group_label-label',
				mandatoryFiled: false
			},
			DataBuildingWidth: {
				label: 'Width',
				type: 'number',
				placeholder: 'Enter Width',
				inputId: 'building_width-input',
				labelId: 'building_width-label',
				mandatoryFiled: false
			},
			DataBuildingNote: {
				label: 'Building Note',
				placeholder: 'Type in your note here',
				classTextarea: 'property-form__textarea',
				inputId: 'building_note-input',
				labelId: 'building_note-label',
				mandatoryFiled: false
			},
			DataBuildingIrregular: {
				label: 'Building Irregular',
				inputId: 'building_irregular-input',
				labelId: 'building_irregular-label',
				mandatoryFiled: false
			},
			DataBuildingLength: {
				label: 'Length',
				type: 'number',
				placeholder: 'Enter Length',
				inputId: 'building_length-input',
				labelId: 'building_length-label',
				mandatoryFiled: false
			},
			DataLotIrregular: {
				label: 'Lot Irregular',
				inputId: 'lot_irregular-input',
				labelId: 'lot_irregular-label',
				mandatoryFiled: false
			},
			DataSizeLot: {
				label: 'Size',
				placeholder: 'Enter Size',
				type: 'number',
				inputId: 'lot_size-input',
				labelId: 'lot_size-label',
				mandatoryFiled: false
			},
			DataLotWidth: {
				label: 'Width',
				type: 'number',
				placeholder: 'Enter Width',
				inputId: 'lot_width-input',
				labelId: 'lot_width-label',
				mandatoryFiled: false
			},
			DataLotLength: {
				label: 'Length',
				type: 'number',
				placeholder: 'Enter Length',
				inputId: 'lot_length-input',
				labelId: 'lot_length-label',
				mandatoryFiled: false
			},
			DataLotNote: {
				label: 'Lot Note',
				placeholder: 'Type in your note here',
				classTextarea: 'property-form__textarea',
				inputId: 'lot_note-input',
				labelId: 'lot_note-label',
				mandatoryFiled: false
			},
			DataZoning: {
				label: 'Zoning',
				placeholder: 'Enter Zoning',
				inputId: 'zoning-input',
				labelId: 'zoning-label',
				mandatoryFiled: true
			},
			DataFar: {
				label: 'FAR',
				placeholder: 'Far',
				inputId: 'far-input',
				labelId: 'far-label',
				mandatoryFiled: false
			},
			DataTotalBuildable: {
				label: 'Total Buildable',
				placeholder: 'Total Buildable',
				inputId: 'total_buildable-input',
				labelId: 'total_buildable-label',
				mandatoryFiled: false
			},
			DataIncome: {
				label: 'Income',
				placeholder: 'Income',
				inputId: 'income-input',
				labelId: 'income-label',
				mandatoryFiled: false,
				type: 'formatPrice'
			},
			DataExpenses: {
				label: 'Expenses',
				placeholder: 'Expenses',
				inputId: 'expenses-input',
				labelId: 'expenses-label',
				mandatoryFiled: false,
				type: 'formatPrice'
			},
			DataNoi: {
				label: 'NOI',
				placeholder: 'NOI',
				inputId: 'noi-input',
				labelId: 'noi-label',
				mandatoryFiled: false
			},
			DataCapRate: {
				label: 'Cap Rate',
				placeholder: 'Cap Rate',
				inputId: 'cap_rate-input',
				labelId: 'cap_rate-label',
				mandatoryFiled: false
			},
			DataNumberOfFloors: {
				label: 'Number of Floors',
				placeholder: 'Number of Floors',
				inputId: 'number_of_floors-input',
				labelId: 'number_of_floors-label',
				mandatoryFiled: false
			},
			DataLayout: {
				label: 'Layout',
				placeholder: 'Layout',
				inputId: 'layout-input',
				labelId: 'layout-label',
				mandatoryFiled: false
			},
			DataGarage: {
				label: 'Garage',
				placeholder: 'Garage',
				inputId: 'garage-input',
				labelId: 'garage-label',
				mandatoryFiled: false
			},
			DataParking: {
				label: 'Parking',
				placeholder: 'Parking',
				inputId: 'parking-input',
				labelId: 'parking-label'
			},
			DataMaterial: {
				label: 'Material',
				placeholder: 'Material',
				inputId: 'material-input',
				labelId: 'material-label',
				mandatoryFiled: false
			},
			DataListingStatus: {
				label: 'Listing Status',
				placeholder: 'Add Status',
				inputId: 'listing_status-input',
				labelId: 'listing_status-label',
				searchable: true,
				mandatoryFiled: true,
				options: []
			},
			DataExclusiveExpiration: {
				label: 'Exclusive Expiration',
				inputId: 'Priority-input',
				labelId: 'Priority-label',
				mandatoryFiled: false
			},
			DataExclusiveExpirationDate: {
				inputId: 'exclusive_expiration_date-input',
				labelId: 'exclusive_expiration_date-label',
				today: '',
				flag: 'exclusive_expiration_date',
				mandatoryFiled: false
			},
			DataListingType: {
				label: 'Listing Type',
				placeholder: 'Add Type',
				inputId: 'listing_type-input',
				labelId: 'listing_type-label',
				searchable: true,
				mandatoryFiled: true,
				options: []
			},
			DataOfferingType: {
				mandatoryFiled: true,
				label: 'Offering Type',
				placeholder: 'Add Type',
				searchable: true,
				inputId: 'offering_type-input',
				labelId: 'offering_type-label',
				options: [],
				multiple: true
			},
			DataAgentsPdf: {
				label: 'Agent',
				placeholder: 'Add Agent',
				inputId: 'agent_pdf-input',
				labelId: 'agent_pdf-label',
				searchable: true,
				mandatoryFiled: false,
				options: []
			},
			DataAgent: {
				label: 'Agent',
				placeholder: 'Enter Agent',
				inputId: 'agent-input',
				labelId: 'agent-label',
				searchable: true,
				mandatoryFiled: true,
				options: []
			},
			DataDescription: {
				mandatoryFiled: true,
				label: 'Description',
				placeholder: 'Type in your description',
				classTextarea: 'property-form__textarea',
				inputId: 'description-input',
				labelId: 'description-label'
			},
			DataNewNote: {
				label: '',
				placeholder: 'Type in your note here',
				classTextarea: 'property-form__textarea',
				inputId: 'note-input',
				labelId: 'note-label',
				mandatoryFiled: false
			},
			DataStreet: {
				label: 'Street',
				placeholder: 'Enter Street',
				classinput: 'full-width',
				inputId: 'street_name-input',
				labelId: 'street_name-label',
				mandatoryFiled: true
			},
			DataStreetNumber: {
				label: 'Street Number',
				placeholder: 'Enter Number',
				type: 'text',
				inputId: 'street_number-input',
				labelId: 'street_number-label',
				mandatoryFiled: true
			},
			DataPostalCode: {
				label: 'Postal Code',
				type: 'text',
				placeholder: 'Enter Code',
				inputId: 'zip-input',
				labelId: 'zip-label',
				mandatoryFiled: true
			},
			DataNeighbourhood: {
				label: 'Neighborhood',
				placeholder: 'Enter Neighborhood',
				inputId: 'neighborhood-input',
				labelId: 'neighborhood-label',
				mandatoryFiled: false
			},
			DataState: {
				label: 'State',
				placeholder: 'Enter State',
				inputId: 'state-input',
				labelId: 'state-label',
				mandatoryFiled: true
			},
			DataCrossStreet: {
				label: 'Cross Street',
				placeholder: 'Enter Street',
				inputId: 'cross_street-input',
				labelId: 'cross_street-label',
				mandatoryFiled: true
			},
			DataPropertyTypeResidential: {
				label: 'Property Type',
				placeholder: 'Add Property Type',
				inputId: 'property_type_residential-input',
				labelId: 'property_type_residential-label',
				searchable: true,
				multiple: false,
				mandatoryFiled: true,
				options: []
			},
			DataPropertyTypeCommercial: {
				mandatoryFiled: true,
				label: 'Property Type',
				placeholder: 'Add Property Type',
				inputId: 'property_type_commercial-input',
				labelId: 'property_type_commercial-label',
				searchable: true,
				multiple: true,
				options: []
			},
			// DataPropertySubTypeResidential: {
			// 	mandatoryFiled: false,
			// 	label: 'Property Sub Type',
			// 	placeholder: 'Add Property Sub Type',
			// 	inputId: 'property_sub_type_residential-input',
			// 	labelId: 'property_sub_type_residential-label',
			// 	searchable: true,
			// 	multiple: false,
			// 	options: []
			// },
			// DataPropertySubTypeCommercial: {
			// 	mandatoryFiled: false,
			// 	label: 'Property Sub Type',
			// 	placeholder: 'Add Property Sub Type',
			// 	inputId: 'property_sub_type_commercial-input',
			// 	labelId: 'property_sub_type_commercial-label',
			// 	searchable: true,
			// 	multiple: false,
			// 	options: []
			// },
			DataArea: {
				label: 'Area',
				placeholder: 'Add Area',
				labelId: 'area-label',
				inputId: 'area-input',
				searchable: true,
				mandatoryFiled: true,
				options: [],
				multiple: false
			},
			DataPrice: {
				label: 'Price',
				placeholder: 'Enter Price',
				type: 'number',
				inputId: 'regular_price-input',
				labelId: 'regular_price-label',
				mandatoryFiled: true,
				currency: true
			},
			DataPriceBuildableSquareFoot: {
				label: 'Price per Buildable Square Foot',
				placeholder: 'Enter Price',
				type: 'number',
				inputId: 'price_buildable_sf-input',
				labelId: 'price_buildable_sf-label',
				mandatoryFiled: false,
				currency: true
			},
			DataPriceSquareFoot: {
				label: 'Price per Square Foot',
				placeholder: 'Enter Price',
				type: 'number',
				inputId: 'price_psf-input',
				labelId: 'price_psf-label',
				mandatoryFiled: false,
				currency: true
			},
			DataLeasePrice: {
				label: 'Lease Price',
				placeholder: 'Enter Lease Price',
				type: 'number',
				inputId: 'lease_price-input',
				labelId: 'lease_price-label',
				mandatoryFiled: true,
				currency: true
			},
			DataPriority: {
				label: 'Priority',
				inputId: 'priority-input',
				labelId: 'priority-label',
				mandatoryFiled: false
			},
			DataPublicize: {
				label: 'Publicize status',
				inputId: 'publicize-input',
				labelId: 'publicize-label',
				mandatoryFiled: false
			},
			DataDateListed: {
				inputId: 'date_listed-input',
				labelId: 'date_listed-label',
				flag: 'date_listed',
				mandatoryFiled: true,
				today: this.edit ? '' : new Date(Date.now())
			},
			DataDateVerified: {
				inputId: 'date_verified-input',
				labelId: 'date_verified-label',
				flag: 'date_verified',
				mandatoryFiled: false
			},
			DataOwnerName: {
				label: 'Owner Name',
				placeholder: 'Enter Owner Name',
				inputId: 'owner_name-input',
				labelId: 'owner_name-label',
				mandatoryFiled: true
			},
			DataOwnerEmail: {
				label: 'Owner Email',
				placeholder: 'Enter Owner Email',
				inputId: 'owner_email-input',
				labelId: 'owner_email-label',
				mandatoryFiled: false
			},
			DataOwnerPhone: {
				label: 'Owner Phone',
				placeholder: 'Enter Owner Phone',
				inputId: 'owner_phone-input',
				labelId: 'owner_phone-label',
				mandatoryFiled: true
			},
			DataOwnerPhone2: {
				label: 'Owner Phone 2',
				placeholder: 'Enter Owner Phone 2',
				inputId: 'owner_phone2-input',
				labelId: 'owner_phone2-label',
				mandatoryFiled: false
			},
			DataOwnerHide: {
				label: 'Hide Owner',
				inputId: 'owner_hide-input',
				labelId: 'owner_hide-label'
			},
			DataYearlyRent: {
				label: 'Use for filtration and matching',
				inputId: 'show_yearly_price-input',
				labelId: 'show_yearly_price-label'
			},
			classScroll: 'prevent-scroll',
			PopupLeavePage: {
				itemID: ''
			},
			goTo: '',
			leavePage: false,
			changeHanlder: false,
			propertyHistory: {
				stickyHeader: true,
				noLocalSorting: false,
				noCollapse: false,
				tableClass: 'text-nowrap',
				fields: [
					{ key: 'type', label: 'Type', sortable: true, stickyColumn: true, variant: 'property' },
					{ key: 'from', label: 'Old value', sortable: true, stickyColumn: true, variant: 'type' },
					{ key: 'to', label: 'New value', sortable: true, stickyColumn: true, variant: 'type' },
					{ key: 'updated_at', label: 'Date updated', sortable: true, stickyColumn: true, variant: 'date-updated', thClass: 'th-history' },
					{ key: 'delete_history', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed table-fixed-icon--red last-icon-fixed' }
				],
				items: []
			},
			haveHistory: false,
			deleteClicked: false,
			// PDFs
			pdf_name: '',
			agent_pdf: '',
			pdf_base64: '',
			cloneProperty: false,
			notFoundProperty: false,
			showPopupDelete: false,
			PopupDelete: {
				itemID: ''
			},
			rowForDelete: null
			// haveYPPSF: true
		};
	},
	components: {
		ValidationProvider,
		ValidationObserver,
		SvgIcon,
		BlockMapInput,
		PartInputBasic,
		BlockGalleryInput,
		PartInputTextarea,
		PartSelect,
		PartCalendar,
		PartNotifications,
		PartCheckboxDropdown,
		BlockEditAgent,
		PartPopupDelete,
		PartSwitch,
		BlockTable,
		VueSimplebar,
		PartLoaderBig,
		PartInputFormatedNum
		// BlockFloorRepeater
	},
	created() {
		if (this.$route.fullPath.includes('clone')) {
			this.cloneProperty = true;
		}
	},
	computed: {
		getCalculateYPPSF() {
			return this.calculateYPPSF();
		},
		checkBuildingSize() {
			if ((this.property.building_size) || this.DataSizeBuilding.mandatoryFiled) {
				return 'required';
			}
			return '';
		},
		checkLotSize() {
			if ((this.property.lot_size) || this.DataSizeLot.mandatoryFiled) {
				return 'required';
			}
			return '';
		}
	},
	mounted() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
		// EDIT MODE
		if (this.edit) {
			this.pageLoader = true;
			this.$store.dispatch('fetchProperty', this.property.id).then(response => {
				this.property = response.data.property;
				this.propertyHistory.items = response.data.history;

				if (response.data.history.length && !this.cloneProperty) {
					this.haveHistory = true;
				}

				// Helper Property is object with default values for compare if something is changed
				this.helperProperty = JSON.parse(JSON.stringify(this.property));

				if (this.property.category === 1) {
					this.helperProperty.property_type_residential = JSON.parse(this.helperProperty.property_type_residential);
				} else {
					this.helperProperty.property_type_commercial = JSON.parse(this.helperProperty.property_type_commercial);
				}

				// Gallery is for upload new images.
				this.property.gallery = [];
				this.helperProperty.gallery = [];

				// Set default values
				this.helperProperty.main_image = this.property.main_image.length ? [this.property.main_image] : [];
				this.helperProperty.map = this.property.map;

				if (response.data.property.map.street) {
					this.$refs.map.renderMap(response.data.property.map);
				}

				// if (this.property.main_pdf) {
				// 	this.pdf_name = this.property.main_pdf.split('/').pop();
				// }

				// TODO check for PDFs and unpersonalized PDFs
				this.unpersonalizedPDFTableData = this.property.propertyPDFs.filter(pdf => pdf.agent_id === null);

				// Skip re-uploading same PDF if it is already uploaded
				if (this.unpersonalizedPDFTableData.length > 0) {
					this.skipUploadingUnpersonaliedPDF = true;
				}

				if (this.property.propertyPDFs.length > 0) {
					// Add Agent Tied PDFs to the table
					this.pdfTable = this.property.propertyPDFs.some(pdf => pdf.agent_id !== null);
				}
				this.property.deletedPDFs = [];
				this.helperProperty.deletedPDFs = [];

				// if (this.property.propertyPDFs.length > 0) {
				// 	this.pdfTable = true;
				// }

				if (this.property.property_shark_link === null) {
					this.helperProperty.property_shark_link = null;
				}

				if (this.cloneProperty) {
					this.resetValuesForClone();
				}

				return this.property;
			}).then(response => {
				this.pageLoader = false;
				for (const key in response) {
					if (this.$refs[key] && this.$refs[key].setValue) {
						this.$refs[key].setValue(this.property[key]);
					}
				}

				this.$refs.propertyForm.reset();
				this.validateInit();

				//	Remove used agents from dropdown for PDF's
				this.removeUsedAgents();
			}).catch(error => {
				this.notFoundProperty = true;
				if (error.response.data.message.includes('No query results')) {
					this.$router.push({ name: '404' });
				}
			});
		}
		this.$store.dispatch('fetchDropDownOptions').then((res) => {
			const data = res.data;
			this.DataAgent.options = JSON.parse(JSON.stringify(data.agents));
			this.DataAgentsPdf.options = data.agents;
			this.DataArea.options = data.areas;
			this.DataListingType.options = data.listing_type;
			this.DataListingStatus.options = data.listing_status;
			this.DataOfferingType.options = data.offering_types;
			this.DataPropertyTypeResidential.options = data.property_type_residential;
			this.DataPropertyTypeCommercial.options = data.property_type_commercial;
			// this.DataPropertySubTypeResidential.options = data.property_sub_type_residential;
			// this.DataPropertySubTypeCommercial.options = data.property_sub_type_commercial;
		});
	},
	watch: {
		property: {
			handler(val) {
				if (val) {
					this.changeHanlder = true;

					// this.DataSizeLot.mandatoryFiled = this.property.offering_type.includes('sale');
				}

				this.haveEmail = !!val.owner_email;
				this.havePhone2 = !!val.owner_phone_2;
				if (this.property.offering_type.includes('lease') && this.property.show_yearly_price) {
					this.DataSizeBuilding.mandatoryFiled = true;
				} else {
					this.DataSizeBuilding.mandatoryFiled = false;
				}
				if (this.property.offering_type.includes('sale')) {
					this.DataSizeLot.mandatoryFiled = true;
				} else {
					this.DataSizeLot.mandatoryFiled = false;
				}
			},
			deep: true
		}
	},
	mixins: [onClickOutside],
	methods: {
		// Upload flyer
		uploadFlyer(e) {
			const files = e.target.files || e.dataTransfer.files;
			this.pdf_flyer_name = files[0].name;
			this.property.pdfFlyer = files[0].name;
			if (!files.length) {
				this.deleteClicked = false;
			} else {
				const idxDot = files[0].name.lastIndexOf('.') + 1;
				const extFile = files[0].name.substr(idxDot, files[0].name.length).toLowerCase();
				if (extFile === 'pdf') {
					toBase64(files[0]).then(base64 => {
						this.property.propertyPDFs.push({
							pdf_name: this.pdf_flyer_name,
							pdf_file: base64,
							agent_id: null,
							agent_name: null
						});
					});
					this.deleteClicked = true;
					this.skipUploadingUnpersonaliedPDF = false;
				} else {
					const msg = 'Only pdf files are allowed!';
					const status = 400;
					this.notificationPdfFlyer(msg, status);
					this.pdf_flyer_name = '';
					this.deleteClicked = false;
				}
			}
		},
		removeFlyerPDF(id) {
			if (this.unpersonalizedPDFTableData.length > 0) {
				this.property.deletedPDFs.push(this.unpersonalizedPDFTableData[0]);
			}
			this.unpersonalizedPDFTableData = [];
			this.pdf_flyer_name = '';
		},
		dragoverFlyer(event) {
			event.preventDefault();
		},
		removeAddedFlyer() {
			this.unpersonalizedPDFTableData = [];
			this.pdf_flyer_name = '';
			this.deleteClicked = false;
		},
		notificationPdfFlyer(msg, status) {
			this.notificationsPdfDataFlyer.msg = msg;
			this.notificationsPdfDataFlyer.type = status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsPdfDataFlyer.msg = '';
				this.notificationsPdfDataFlyer.type = '';
			}, 2000);
		},
		// ////////////////
		getAgentName(id) {
			let agentName;
			this.DataAgent.options.forEach(el => {
				if (el.id === id) {
					agentName = el.label;
				}
			});
			return agentName;
		},
		removeUsedAgents() {
			setTimeout(() => {
				this.property.propertyPDFs.forEach(el => {
					const index = this.DataAgentsPdf.options.findIndex(x => x.id === el.agent_id);
					if (index > -1) {
						this.DataAgentsPdf.options.splice(index, 1);
					}
				});
			}, 1000);
		},
		// Upload file
		uploadPDF(e) {
			const files = e.target.files || e.dataTransfer.files;
			this.pdf_name = files[0].name;
			if (!files.length) {
				this.deleteClicked = false;
			} else {
				const idxDot = files[0].name.lastIndexOf('.') + 1;
				const extFile = files[0].name.substr(idxDot, files[0].name.length).toLowerCase();
				if (extFile === 'pdf') {
					this.createDocument(files[0]);
					this.deleteClicked = true;
				} else {
					const msg = 'Only pdf files are allowed!';
					const status = 400;
					this.notificationPdf(msg, status);
				}
			}
		},
		dragover(event) {
			event.preventDefault();
		},
		createDocument(file) {
			const reader = new FileReader();
			const vm = this;
			reader.onload = (e) => {
				// vm.property.main_pdf = e.target.result;
				vm.pdf_base64 = e.target.result;
			};
			reader.readAsDataURL(file);
		},
		removeAddedPDF() {
			this.pdf_name = '';
			// this.property.main_pdf = '';
			this.deleteClicked = false;
		},
		// adding file in row
		addPDF() {
			if ((this.pdf_name !== '') && (this.agent_pdf !== '')) {
				this.property.propertyPDFs.push({
					pdf_name: this.pdf_name,
					pdf_file: this.pdf_base64,
					agent_id: this.agent_pdf,
					agent_name: this.getAgentName(this.agent_pdf)
				});
				this.pdfTable = true;
				this.pdf_name = '';
				this.deleteClicked = false;
				this.removeAgentFromDrop(this.agent_pdf);
				// this.property.main_pdf = '';
			}
		},
		removeAgentFromDrop(agentID) {
			const updatedDataAgentsPdf = this.DataAgentsPdf.options.filter(el => {
				return el.id !== agentID;
			});
			this.DataAgentsPdf.options = updatedDataAgentsPdf;
			this.agent_pdf = '';
			this.$refs.agent_pdf.setValue('');
		},
		removePDF(index) {
			// Add agent back to dropdown
			this.DataAgentsPdf.options.push({
				id: this.property.propertyPDFs[index].agent_id,
				label: this.property.propertyPDFs[index].agent_name
			});

			// Send PDF on BE if is already uploaded on server
			if (!this.property.propertyPDFs[index].pdf_file) {
				this.property.deletedPDFs.push(this.property.propertyPDFs[index]);
			}

			// Remove PDF from table
			this.property.propertyPDFs.splice(index, 1);

			// Hide table if is empty
			if (this.property.propertyPDFs.length < 1) {
				this.pdfTable = false;
			}
		},
		disablePDFBtn() {
			return ((this.pdf_name !== '') && (this.agent_pdf !== ''));
		},
		// popup for agent
		showPopup() {
			this.showModal = true;
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
		},
		closePopup() {
			this.showModal = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		setAgent(agentId) {
			this.$store.dispatch('fetchAgentsSimple').then((res) => {
				this.DataAgent.options = res.data.agents;
				this.$refs.agent.setValue(agentId);
			});
		},

		addNewAndEditProperty() {
			this.$refs.propertyForm.validate().then(success => {
				if (success) {
					// Set status for publish
					this.property.status = 1;
					this.btnIsDisabled = true;
					this.generateTitle();
					this.pageLoader = true;

					if (this.property.delete_main_image === undefined) {
						this.property.delete_main_image = false;
						this.helperProperty.delete_main_image = false;
					}

					// Prepare for upload only PDFs with Agents Tied to them
					if (this.skipUploadingUnpersonaliedPDF) {
						this.property.propertyPDFs = this.property.propertyPDFs.filter(pdf => {
							return pdf.agent_id !== null;
						});
					}

					if (this.cloneProperty) {
						this.property.id = 0;
						this.helperProperty.id = 0;
						if (this.propertyChanged(this.helperProperty, this.property)) {
							this.pageLoader = false;
							const msg = 'This property already exists.';
							const status = 400;
							this.notification(msg, status);

							setTimeout(() => {
								this.btnIsDisabled = false;
							}, 1000);

							window.scrollTo({
								top: 0,
								behavior: 'smooth'
							});
							return;
						}
					}

					this.checkPrices();

					this.$store.dispatch('updateProperty', this.property).then(() => {
						this.$router.push({ name: 'Properties' });
						this.pageLoader = false;
					});
				} else {
					this.pageLoader = false;
					this.btnIsDisabled = false;
					// error messages list
					this.createErrorList();
				}
			});
		},

		// Check and reset new prices
		checkPrices() {
			if (!this.property.offering_type.includes('lease')) {
				this.property.lease_price = '';
				this.property.yearly_price = '';
				this.property.show_yearly_price = false;
			}

			if (!this.property.offering_type.includes('sale')) {
				this.property.regular_price = '';
			}

			if (!this.contains(this.property.property_type_commercial, ['land', 'commercial-development', 'residential-development'])) {
				this.property.price_buildable_sf = '';
			}

			if (!this.contains(this.property.property_type_commercial, ['industrial', 'warehouse-distribution'])) {
				this.property.price_psf = '';
			}
		},

		// Confirm popup for leave page
		cancelProperty() {
			if (this.property.status === 1 && this.edit) {
				this.$router.push({ name: 'Properties' });
			} else if (this.property.status === 0 || (this.property.status === 1 && !this.edit)) {
				this.draftProperties();
			}
		},
		confirmPopupLeave() {
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
			this.leavePage = true;
			this.$router.push({ name: this.goTo ? `${this.goTo}` : 'Properties' });
		},
		closePopupLeave() {
			this.showPopupLeavePage = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},

		draftProperties() {
			if (this.changeHanlder && !this.btnIsDisabled) {
				this.property.status = 0;
				this.pageLoader = true;
				this.generateTitle();
			}
			this.$router.push({ name: 'Properties' });
		},

		createErrorList() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});

			this.errors = [];
			this.DataSizeBuilding.mandatoryFiled = this.property.show_yearly_price;

			if (this.property.street_name && this.property.street_number &&
				this.property.zip && this.property.state && this.property.cross_street &&
				this.property.area && this.property.zoning && this.property.owner_name && (this.property.owner_phone_2 && this.property.owner_phone_2.length >= 5) &&
				this.property.owner_phone && (this.property.owner_phone.length >= 5) && this.property.regular_price &&
				(this.property.offering_type.length > 0) && (this.property.property_type_commercial.length > 0) &&
				(this.property.offering_type.includes('lease') && this.property.lease_price) &&
				this.pdf_flyer_name.length < 1 && this.property.listing_status && this.property.listing_type && this.property.offering_type && this.property.date_listed &&
				this.property.agent && this.property.description && this.property.lot_size && (this.property.owner_email && this.property.building_size &&
				this.validEmail(this.property.owner_email))) {
				return true;
			}

			if (!this.property.street_name) this.errors.push('Street Name is required.');
			if (!this.property.street_number) this.errors.push('Street Number is required.');
			if (!this.property.zip) this.errors.push('Postal Code is required.');
			if (!this.property.state) this.errors.push('State is required.');
			if (!this.property.cross_street) this.errors.push('Cross Street is required.');
			if (this.property.area.length === 0) this.errors.push('Area is required.');
			if (!this.property.zoning) this.errors.push('Zoning is required.');
			if (!this.property.owner_name) this.errors.push('Owner Name is required.');
			if (this.pdf_flyer_name.length < 1) this.errors.push('It is required to add a flyer pdf.');
			if (!this.property.owner_phone) this.errors.push('Owner Phone is required.');
			if (this.property.owner_phone && this.property.owner_phone.length < 5) this.errors.push('Phone must contain valid information.');
			if (this.property.owner_phone_2 && this.property.owner_phone_2.length < 5) this.errors.push('Phone must contain valid information.');
			if (!this.property.regular_price && this.property.regular_price !== 0 && this.property.offering_type.includes('sale')) this.errors.push('Price is required.');
			if (this.property.property_type_commercial.length === 0) this.errors.push('Property Type is required.');
			if (!this.property.listing_status) this.errors.push('Listing Status is required.');
			if (!this.property.listing_type) this.errors.push('Listing Type is required.');
			if (this.property.offering_type.length === 0) this.errors.push('Offering Type is required.');
			if ((this.property.offering_type.includes('lease') && !this.property.lease_price && this.property.lease_price !== 0)) this.errors.push('Lease Price is required.');
			if (this.property.show_yearly_price && (!this.property.building_size && this.property.building_size !== 0)) this.errors.push('Building Size is required.');
			if (!this.property.date_listed) this.errors.push('Date Listed is required.');
			if (!this.property.agent) this.errors.push('Agent is required.');
			if (!this.property.description) this.errors.push('Description is required.');
			if (!this.property.lot_size && this.property.lot_size !== 0 && this.property.offering_type.includes('sale')) this.errors.push('Lot Size is required.');
			if (this.property.owner_email && !this.validEmail(this.property.owner_email)) this.errors.push('Owner email must contain valid information.');

			// Turn off notification for existing property if is active
			this.closeNotificaitonExist();
			return false;
		},
		validEmail: function (email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		notification(msg, status) {
			this.notificationsData.msg = msg;
			this.notificationsData.type = status === 200 ? 'success' : 'danger';

			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		notificationPdf(msg, status) {
			this.notificationsPdfData.msg = msg;
			this.notificationsPdfData.type = status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsPdfData.msg = '';
				this.notificationsPdfData.type = '';
			}, 2000);
		},

		notificationsExist(msg, status) {
			this.notificationsExistData.msg = msg;
			this.notificationsExistData.type = status;
		},

		closeNotificaitonExist() {
			setTimeout(() => {
				this.notificationsExistData.msg = '';
				this.notificationsExistData.type = '';
			}, 500);
		},

		// Return false if property is changed
		propertyChanged(x, y) {
			const ok = Object.keys;
			const tx = typeof x === 'object';
			const ty = typeof y === 'object';
			return x && y && tx && ty ? (
				ok(x).length === ok(y).length &&
				ok(x).every(key => this.propertyChanged(x[key], y[key]))
			) : (x === y);
		},

		generateTitle() {
			let title = '';
			if (this.property.street_number) {
				title += `${this.property.street_number}`;
			}
			if (this.property.street_name) {
				title += ` ${this.property.street_name}`;
			}

			if (this.property.area) {
				if (this.property.area === 'near-brooklyn') {
					title += ', New Jersey';
				} else if (this.property.area === 'near-boro-park') {
					title += ', Brooklyn';
				} else {
					const newArea = this.property.area.replaceAll('-', ' ');
					const arr = newArea.split(' ');
					for (let i = 0; i < arr.length; i++) {
						arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
					}
					const finalArea = arr.join(' ');
					title += `, ${finalArea}`;
				}
			}

			if (this.property.zip) {
				title += `, ${this.property.zip}`;
			}

			if (this.property.neighborhood) {
				title += `, (${this.property.neighborhood})`;
			}

			this.property.title = title;
		},

		// TODO: POST-MVP
		// setCategory(category) {
		// 	this.property.category = category;
		//
		// 	for (const key in this.property) {
		// 		if (this.$refs[key] && this.$refs[key].setValue) {
		// 			this.$refs[key].setValue(this.property[key]);
		// 		}
		// 	}
		// 	setTimeout(() => {
		// 		this.$refs.propertyForm.reset();
		// 	}, 100);
		// },
		isResidential() {
			return this.property.category === 1;
		},
		isFlyerPDFFieldValid() {
			return this.unpersonalizedPDFTableData.length > 0 || this.pdf_flyer_name !== '';
		},

		fillAddress(place) {
			this.$refs.street_name.setValue(place.street);
			this.$refs.street_number.setValue(place.streetNumber);
			this.$refs.zip.setValue(place.postcode);
			this.$refs.neighborhood.setValue(place.neighborhood);
			this.$refs.state.setValue(place.state);

			const checkInfo = {
				street_name: place.street,
				street_number: place.streetNumber,
				zip_code: place.postcode
			};

			this.$store.dispatch('checkPropertyAddress', checkInfo).then(res => {
				if (res.data.response) {
					this.notificationsExist(res.data.message, 'warning');
				}
			});

			const ids = this.DataArea.options.map(d => d.id);

			this.DataArea.options.forEach(d => {
				if (d.children) {
					d.children.forEach(child => {
						ids.push(child.id);
					});
				}
			});
			if (place.address !== '' && ids.includes(place.address)) {
				place.area = place.area.replace(' ', '-');
			} else {
				if (place.state === 'NJ') {
					this.$refs.area.setValue('new-jersey');
				} else if (place.area === 'staten island') {
					this.$refs.area.setValue('staten-island');
				} else if (place.area === 'manhattan') {
					this.$refs.area.setValue('manhattan');
				} else if (place.area === 'bronx') {
					this.$refs.area.setValue('bronx');
				} else if (place.area === 'brooklyn') {
					this.$refs.area.setValue('brooklyn');
				} else if (place.area === 'queens') {
					this.$refs.area.setValue('queens');
				} else {
					this.$refs.area.setValue('other');
				}
			}
			// this.$refs.area.setValue(place.area);
			this.property.map = place;
		},
		resetAddress() {
			this.$refs.street_name.setValue('');
			this.$refs.street_number.setValue('');
			this.$refs.zip.setValue('');
			this.$refs.neighborhood.setValue('');
			this.$refs.state.setValue('');
			this.$refs.cross_street.setValue('');
			this.$refs.area.inputVal = null;
		},

		deletedImages(deletedImages) {
			this.property.deleted_images = deletedImages;
		},
		uploadImages(uploadImages) {
			this.property.gallery = uploadImages;
		},
		setMainImage(mainImage) {
			this.property.main_image = mainImage;
		},
		deleteMainImage(deleteMainImage) {
			this.property.delete_main_image = deleteMainImage;
		},

		changeDateFormat(date) {
			return formatDate(date);
		},
		changeVal(date, flag) {
			this.$refs[flag] = date.toISOString();
		},

		resetValuesForClone() {
			this.property.gallery_absolute = [];
			this.helperProperty.gallery_absolute = [];
			this.property.main_image = [];
			this.helperProperty.main_image = [];
			this.property.main_image_absolute = '';
			this.helperProperty.main_image_absolute = '';
			this.property.property_shark_link = null;
			this.helperProperty.property_shark_link = null;
			this.$refs.gallery_absolute.resetValue();
			// this.property.main_pdf = '';
			// this.helperProperty.main_pdf = '';
			this.pdf_name = '';
			this.property.propertyPDFs = [];
			this.helperProperty.propertyPDFs = [];
			this.property.deletedPDFs = [];
			this.pdfTable = false;
			this.building_size = '';
		},
		validateInit() {
			this.btnIsDisabled = true;
			this.$refs.propertyForm.validate().then(success => {
				if (success) {
					this.btnIsDisabled = false;
				} else {
					this.pageLoader = false;
					this.btnIsDisabled = false;
					const msg = 'You have not filled in all required fields.';
					const status = 400;
					this.notification(msg, status);
					window.scrollTo({
						top: 0,
						behavior: 'smooth'
					});
				}
			});
		},
		//	Check if user select appropriate value in dropdown and show/hide new fields for prices
		contains(choosenValues, valueForCheck) {
			if (choosenValues && choosenValues.length && Array.isArray(choosenValues)) {
				let hit = false;
				choosenValues.forEach(choosenEl => {
					valueForCheck.forEach(checkEl => {
						if (choosenEl === checkEl) {
							hit = true;
						}
					});
				});
				return hit;
			} else if (choosenValues && choosenValues.length && !Array.isArray(choosenValues)) {
				if (valueForCheck.includes(choosenValues)) {
					return true;
				}
				return false;
			}
		},
		// Calculate Yearly Price per Square Foot
		calculateYPPSF() {
			let res;
			if (this.property.building_size > 0) {
				res = (parseFloat(this.property.lease_price) * 12) / parseFloat(this.property.building_size);
			}

			const formatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD'
			});

			if (isNaN(res)) {
				res = 0;
			}
			// this.haveYPPSF = res > 0;

			this.property.yearly_price = parseFloat(res).toFixed(2);
			this.helperProperty.yearly_price = parseFloat(res).toFixed(2);

			return formatter.format(res);
		},
		deleteHistoryRow(item) {
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
			this.showPopupDelete = true;
			this.PopupDelete.itemID = item.id;
			this.rowForDelete = {
				history_id: item.id,
				property_id: item.property_id
			};
		},
		closePopupDelete() {
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
			this.showPopupDelete = false;
		},
		confirmPopupDelete() {
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
			this.showPopupDelete = false;
			this.$store.dispatch('deleteHistoryRow', this.rowForDelete).then(() => {
				this.$store.dispatch('fetchProperty', this.property.id).then(response => {
					this.propertyHistory.items = response.data.history;
					if (response.data.history.length && !this.cloneProperty) {
						this.haveHistory = true;
					}
				});
			});
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.notFoundProperty) {
			next();
		}
		if (this.edit && this.property.status === 1) {
			if (this.btnIsDisabled) {
				next();
			} else {
				if (!this.propertyChanged(this.property, this.helperProperty)) {
					this.showPopupLeavePage = true;
					this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
					this.goTo = to.name;
					if (this.leavePage) {
						this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
						next();
					}
				} else {
					this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
					next();
				}
			}
		} else {
			// Set status for drafts
			if (this.changeHanlder && !this.btnIsDisabled) {
				this.property.status = 0;
				this.pageLoader = true;
				this.generateTitle();
				this.$store.dispatch('updateProperty', this.property);
				next();
			} else {
				next();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.page-edit-property {
	padding-right: 40px;

	@include mq($xl) {
		padding-right: 0;
	}
}

.popup__close {
	position: absolute;
	right: 15px;
	top: 15px;
	color: $fiord;
	font-size: 20px;
	cursor: pointer;
}

.popup__new-agent {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	z-index: 999999;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba($slate-gray, .5);
}

.btn--disabled {
	opacity: .5;
	cursor: default !important;

	@include hover {
		background-color: $dodger-blue;
		color: $white;
	}
}

.container-fluid--bottom-btn {
	@include mq($sm) {
		padding: 0;
	}
}

.admin-single-property__breadcrumbs {
	display: flex;
	justify-content: space-between;
	position: relative;
	margin-bottom: 45px;
	padding-right: 15px;
	overflow: hidden;

	@include mq (1500px) {
		flex-wrap: wrap;
		padding: 15px 15px 15px 0;
		.notification-wrap-center {
			order: 3;
			width: 100%;
		}
	}

	@include mq($xl) {
		padding: 15px 0;
	}

	@include mq($lg) {
		margin-bottom: 20px;
	}

	&::after {
		content: '';
		width: 111%;
		height: 1px;
		position: absolute;
		left: -46px;
		bottom: 0;
		background-color: $grey-light;

		@include mq($xl) {
			left: -15px;
			width: 103%;
		}
	}

	.notification-wrap-center {
		display: flex;
		position: relative;
		left: auto;
		transform: none;
		top: auto;
		align-items: center;
	}
}

.admin-single-property__breadcrumbs-wrap {
	display: flex;
	align-items: center;
	padding: 31px 17px 31px;
	min-width: fit-content;
	max-width: 40%;

	@include mq(1500px) {
		padding: 20px 0;
		margin-right: 15px;
	}

	@include mq($xl) {
		padding: 0 0 10px;
		max-width: 100%;
	}
}

.section-title--breadcrumbs {
	display: block;

	@include mq($md) {
		font-size: 18px;
	}

	@include mq($sm) {
		font-size: 16px;
	}

	@include mq(400px) {
		font-size: 14px;
	}
}

.breadcrumbs__button {
	display: flex;
	align-items: center;

	@include mq($xl) {
		justify-content: flex-end;
		margin-left: auto;
	}

	.breadcrumbs__button-btn {
		min-width: 147px;

		@include mq($md) {
			min-width: 100px;
			max-width: 147px;
		}

		&:not(:first-child) {
			margin-left: 14px;

			@include mq($md) {
				margin-left: 20px;
			}
		}
	}
}

.save-icon {
	margin-right: 11px;
	svg {
		font-size: 20px;
		color: $white;
	}
}

.admin-property__content {
	max-width: 100%;
	width: 100%;

	.container-fluid {
		@include mq($xl) {
			padding: 0;
		}
	}
}

.loader-dashboard {
	.loader-big {
		position: fixed;
	}
}

/*--------------------------------------------------------------
## Map
--------------------------------------------------------------*/
.property-form__input-title {
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: $white;
	background-color: $fiord;
	padding: 13px 12px;
	display: flex;
	margin-bottom: 18px;
}

.admin-property__map {
	margin-bottom: 52px;

	@include mq($xl) {
		margin-bottom: 40px;
	}

	@include mq($lg) {
		margin-bottom: 20px;
	}
}

.admin-property__map {
	position: relative;
}

.property-form__input-address {
	position: absolute;
	z-index: 1;
	top: 5px;
	max-width: 100%;
	width: 100%;
}

.property-form__input-address-form {
	position: relative;
	max-width: 100%;
	padding: 0 20px 0 14px;

	@include mq($xl) {
		padding: 0 15px;
	}
}

.property-form-box-loc-remove {
	position: absolute;
	color: $fiord;
	right: 37px;
	top: 50%;
	transform: translateY(-50%);
	height: 23px;
	width: 10px;
	font-size: 15px;
	transition: $dur $ease;

	@include hover {
		color: $dodger-blue;
	}
}

/*--------------------------------------------------------------
## Gallery
--------------------------------------------------------------*/
.admin-property__gallery {
	min-height: 460px;

	@include mq($lg) {
		min-height: auto;
		margin-bottom: 40px;
	}
}

/*--------------------------------------------------------------
## Single property
--------------------------------------------------------------*/
.property-form__input-title {
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: $white;
	background-color: $fiord;
	padding: 13px 12px;
	display: flex;
	margin-bottom: 18px;
}

.property-form__input--half {
	display: flex;
}

.property-form__input--agent {
	display: flex;
	align-items: center;
	justify-content: space-between;
	@include mq(900px) {
		flex-direction: column;
	}
}

.property-form-agents__icon {
	margin-right: 5px;
}

.property-form__input--half-big {
	@include mq(1440px) {
		max-width: 100%;
		justify-content: flex-start;
	}
}

.property-form__input--half-sm-fields {
	@include mq(1800px) {
		max-width: 100%;
		justify-content: flex-start;
	}
}

.property-form__input-small {
	max-width: 160px;
	position: relative;

	@include mq($lg) {
		max-width: 48%;
	}

	@include mq(350px) {
		max-width: 100%;
	}

	&:not(:last-of-type) {
		margin-right: 35px;

		@include mq(1440px) {
			margin-right: 20px;
		}

		@include mq(350px) {
			margin-right: 0;
		}
	}
}

.property-form__input-btn-new-agent {
	flex: 0 0 25%;
	max-width: 25%;
	display: flex;
	justify-content: flex-end;

	@include mq(1700px) {
		flex: 0 0 35%;
		max-width: 35%;
	}

	@include mq(900px) {
		flex: 0 0 100%;
		justify-content: center;
		max-width: 100%;
		align-self: center;
	}
}

.admin-property__switch-container {
	margin-bottom: 45px;

	@include mq($xl) {
		padding: 0;
		margin-bottom: 30px;
	}

	@include mq($lg) {
		margin-bottom: 20px;
	}
}

.admin-property__switch-wrap {
	display: flex;
	align-items: center;
	border: 1px solid $dodger-blue;
	max-width: 400px;
	width: 100%;
}

.admin-property__switch {
	background-color: $white;
	color: $dodger-blue;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 50%;
	transition: $dur $ease;

	a {
		font-family: $font-main;
		font-weight: 500;
		font-size: 14px;
		line-height: 1.3;
		margin: 0;
		padding: 10px;
		max-width: 100%;
		width: 100%;
		text-align: center;
		cursor: pointer;
	}

	&.is-active {
		background-color: $dodger-blue;
		color: $white;
	}
}

.property-form__input--switch {
	@include mq($xl) {
		justify-content: space-between;
	}
	@include mq($lg) {
		.property-form__input {
			margin: 0;
		}
	}
}

.property-form__input--half-wrap-small {
	@include mq($lg) {
		flex-direction: column;

		.property-form__input--half {
			margin-right: 10px;
		}

		.property-form__input--half .input__wrapper {
			justify-content: space-between;

			@include mq($md) {
				justify-content: flex-start;
			}
		}
	}

	@include mq($md) {
		justify-content: space-between;
		.property-form__input--half {
			max-width: 100%;
			width: 100%;
		}
	}

	@include mq($sm) {
		.property-form__input--half {
			max-width: 100%;
			width: 100%;
		}
	}
}

.history__table {
	margin-bottom: 25px;

	@include mq($lg) {
		margin-bottom: 15px;
	}
}

.history__title {
	margin-bottom: 10px;
	font-size: 20px;

	@include mq($lg) {
		font-size: 18px;
		margin-bottom: 20px;
	}

	@include mq($md) {
		font-size: 16px;
	}

	@include mq($sm) {
		font-size: 15px;
	}

	&--date {
		margin-bottom: 6px;
	}
}

.section-subtitle {
	display: block;
	font-family: $font-main;
	font-weight: 400;
	font-size: 16px;
	color: $shuttle-gray;
}

.property-form__input--half-wrap {
	.property-form__input--half {
		&:first-of-type {
			margin-right: 10px;

			@include mq($sm) {
				margin-right: 0;
			}
		}
	}
}

.error-message-holder {
	width: 100%;
}

.property-form {
	.property-form__input-btn-new-agent {
		margin-bottom: -12px;

		@include mq(900px) {
			margin-bottom: 15px;
		}
	}
}

.property-form__bottom-button {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 20px;

	.property-form__bottom-btn {
		min-width: 147px;
		max-width: 147px;

		@include mq($md) {
			min-width: 100px;
		}

		&:not(:first-child) {
			margin-left: 14px;

			@include mq($md) {
				margin-left: 20px;
			}
		}
	}
}

.property-form__wrap {
	padding-bottom: 20px;

	@include mq($lg) {
		padding-bottom: 0;
	}
}

.error-message {
	bottom: -20px;
	display: inline-block;
	transform: none;

	@include mq($md) {
		bottom: -17px;
	}
}

.property-form__input--owner {
	.error-message-holder {
		position: relative;
	}

	.error-message {
		top: 104%;
	}
}

.select-big-input,
.property-form__input--agent,
.property-form__input--select,
.property-form__input--decoration {
	.error-message {
		bottom: -22px;

		@include mq($md) {
			bottom: -17px;
		}
	}
}

.property-form__input-half-sm {
	position: relative;
	.error-message {
		bottom: 0;

		@include mq(1440px) {
			width: 110%;
		}

		@include mq($xl) {
			width: 100%;
		}
	}
}

.property-form__input--decoration {
	.error-message {
		bottom: -20px;

		@include mq($md) {
			bottom: -17px;
		}
	}
}

.upload-btn-wrapper {
	position: relative;
	cursor: pointer;
	max-width: 208px;
	width: 100%;

	@include mq($md) {
		max-width: 100%;
	}
}

.uploaded-file {
	display: flex;
	border: 2px dashed #7a869a;
	box-sizing: border-box;
	border-radius: 8px;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;
	padding: 10px 5px 10px 10px;

	&:hover {
		.uploaded-file-tooltip {
			opacity: 1;
			visibility: visible;
		}
	}
}

.remove-pdf-icon {
	cursor: pointer;
	transition: $dur $ease;
	color: $fiord;

	@include hover {
		color: $dodger-blue;
	}
}

.upload-btn-wrapper input[type=file] {
	font-size: 23px;
	cursor: pointer;
	position: absolute;
	left: 0;
	top: 0;
	opacity: 0;
	max-width: 100%;
	width: 100%;
}

.upload-btn-wrapper-inner {
	display: flex;
	align-items: center;
}

.uploaded-file-info {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.remove-file {
	height: 20px;
}

.add-pdf-icon,
.remove-pdf-icon {
	font-size: 16px;
	height: 16px;
}

.add-pdf-icon {
	margin-right: 10px;
}

.uploaded-file-tooltip {
	position: absolute;
	bottom: 65%;
	max-width: 100%;
	z-index: 2;
	background-color: $white;
	padding: 10px;
	border-radius: 10px;
	box-shadow: 1px 1px 15px -5px $black;
	opacity: 0;
	visibility: hidden;
	transition: $dur $ease;
	pointer-events: none;
	font-size: 14px;
	display: block;
	font-family: $font-main;
	word-break: break-all;
	line-height: 1.2;
	color: $fiord;

	@include mq($sm) {
		font-size: 13px;
	}
}

.arrow-angle {
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 8px 11px 10px;
	border-color: transparent transparent #fff transparent;
	bottom: -8px;
	position: absolute;
	left: 17px;
	transform: rotateX(187deg) translateX(-50%);
	box-shadow: 1px 1px 15px -5px #000;
	z-index: 8;
}

.error-messages__list {
	margin: -25px auto 20px;

	@include mq($xl) {
		margin: -10px auto 20px;
	}

	@include mq($lg) {
		margin: 0 auto 20px;
	}
}

.property-form__input-lease-notification {
	display: flex;

}
.property-form__input-notificaation-error {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $red;
	padding: 10px 0;

	@include mq(1800px) {
		padding: 20px 0;
	}
}

.property-form__input-notificaation-suc {
		display: block;
		font-size: 14px;
		font-family: $font-main;
		line-height: 1.2;
		color: $slate-gray;
		display: flex;
		align-items: center;
		padding: 10px 0;

		@include mq(1800px) {
			padding: 20px 0;
		}

		@include mq(600px) {
			padding: 0;
		}

	span {
		display: block;
		padding-left: 5px;
		line-height: 1.2;
		font-size: 14px;
		font-weight: bold;
		color: $fiord;
		transition: $dur $ease;
	}
}

.property-form__input--mix-checkbox {
	@include mq($lg) {
		flex-direction: column;

		.property-form__input--half {
			max-width: 100%;
			flex: 0 0 100%;
		}
	}
}

.property-form__input--checkbox {
	@include mq($lg) {
		flex-direction: column;
	}
}

.property-form__input--select-single,
.property-form__input--half-checkboxdrop {
	max-width: 45%;
    flex: 0 0 45%;
    width: 100%;

	@include mq($lg) {
		max-width: 100%;
		flex: 0 0 100%;
	}
}

.property-form__pdf-table {
	max-height: 210px;
	overflow: auto;
	transition: $dur $ease;
	position: relative;
	margin-bottom: 30px;

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
	scrollbar-width: thin;
	scrollbar-color: #42526e #eceeef;
}

.property-form__pdf-table-wrap {
	width: 100%;
	transition: $dur $ease;

	th {
		color: $white;
		padding: 5px 5px 5px 14px !important;//sass-lint:disable-line no-important
		font-family: $font-main;
		font-size: 14px;
		line-height: 1,1;
		position: sticky;
		padding: 7px 6px 7px 14px !important;//sass-lint:disable-line no-important
		position: -webkit-sticky !important;//sass-lint:disable-line no-important
		top: 0;
		background-color: $fiord !important;//sass-lint:disable-line no-important
		left: 0;
		width: 50%;
	}

	td {
		width: 50%;
		font-family: $font-main;
		font-size: 14px;
		line-height: 1,1;
		align-items: center;
		color: $fiord;
		border: none;
		border-top: none;
		vertical-align: inherit;
		padding: 7px !important;//sass-lint:disable-line no-important
		display: table-cell;
		position: relative;
		transition: 0.2s $ease;
		word-wrap: break-word;
		white-space: normal;
		background-color: $white !important;//sass-lint:disable-line no-important

		&:first-of-type {
			position: relative;
			position: -webkit-relative !important;//sass-lint:disable-line no-important
			z-index: 7;

			&::after {
				display: none;
			}
		}

		@include mq($md) {
			font-size: 13px;
		}

		@include mq($sm) {
			font-size: 12px;
		}

		&:focus {
			outline: none;
		}

		&:first-of-type {
			border-right: 1px solid $grey-light;
			background-color: rgba(244, 245, 247, 1);

		}

		span {
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			position: relative;
		}

		&.property-form__pdf-table-icon--body {
			position: relative;
			span {
				position: absolute;
				top: 50%;
				transform: translate(-50%, -50%);
				left: 50%;
				font-size: 15px;
				width: 20px;
			}
		}
	}
}

.property-form__pdf-table-icon {
	max-width: 40px !important;//sass-lint:disable-line no-important
	min-width: 40px !important;//sass-lint:disable-line no-important
	width: 40px !important;//sass-lint:disable-line no-important

	@include mq($sm) {
		max-width: 30px !important;//sass-lint:disable-line no-important
		min-width: 30px !important;//sass-lint:disable-line no-important
		width: 30px !important;//sass-lint:disable-line no-important
		top: 0;
		position: sticky !important;//sass-lint:disable-line no-important
		position: -webkit-sticky !important;//sass-lint:disable-line no-important
		transition: $dur $ease;
		right: 0;
	}

	a {
		transition: $dur $ease;
		@include hover {
			color: $dodger-blue
		}
	}
}

.property-form__input--pdf-big {
	@include mq(1500px) {
		flex-wrap: wrap;
		justify-content: space-between;
	}
}

.property-form__input-half-pdf {
	position: relative;
	flex: 0 0 40%;
	max-width: 40%;

	@include mq(1500px) {
		max-width: 45%;
		flex: 0 0 45%;
	}

	@include mq(500px) {
		max-width: 100%;
		flex: 0 0 100%;
	}

	&--btn {
		display: flex;
		align-items: flex-end;
		margin-bottom: 29px;
		max-width: 15%;
		flex: 0 0 15%;

		.btn--pdf {
			max-width: 120px;
		}

		@include mq(1500px) {
			width: 100%;
			max-width: 45%;
			flex: 0 0 45%;
			justify-self: flex-end;
			margin-left: auto;
			margin-bottom: 0;

			a {
				margin-left: auto;
			}
		}
	}
}

.disable-btn {
	a {
		pointer-events: none;
		opacity: 0.5;
	}
}

.btn--pdf--upload {
	@include mq(500px) {
		max-width: 100%;
	}
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
/* flyeer */
.upload-flyer__wrap-upload-file {
	height: 48px;
}

.upload-flyer {
	position: relative;
	max-width: 100%;
	width: 100%;
}

.upload-flyer__input {
	flex: 0 0 auto;
	max-width: fit-content;
	min-width: 50%;
	margin-bottom: 20px;

	@include mq($sm) {
		max-width: 100%;
		min-width: 100%;
	}
}

.upload-flyer__holder {
	position: relative;
	cursor: pointer;
	max-width: 208px;
	width: 100%;

	@include mq($md) {
		max-width: 100%;
	}
}

.uploaded-file {
	display: flex;
	border: 1px solid $seashell;
	box-sizing: border-box;
	border-radius: 8px;
	align-items: center;
	color: $fiord;
	justify-content: space-between;
	margin-bottom: 20px;
	padding: 5px;

	&:hover {
		.uploaded-file-tooltip {
			opacity: 1;
			visibility: visible;
		}
	}
}

.remove-pdf-icon {
	cursor: pointer;
	transition: $dur $ease;
	color: $fiord;

	@include hover {
		color: $dodger-blue;
	}
}

.upload-flyer__holder input[type=file] {
	font-size: 23px;
	cursor: pointer;
	position: absolute;
	left: 0;
	top: 0;
	opacity: 0;
	max-width: 100%;
	width: 100%;
}

.upload-flyer__holder-inner {
	display: flex;
	align-items: center;
}

.uploaded-file-info {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.remove-file {
	height: 20px;
}

.add-pdf-icon,
.remove-pdf-icon {
	font-size: 16px;
	height: 16px;
}

.add-pdf-icon {
	margin-right: 10px;
}

.uploaded-file-tooltip {
	position: absolute;
	bottom: 65%;
	max-width: 100%;
	z-index: 2;
	background-color: $white;
	padding: 10px;
	border-radius: 10px;
	box-shadow: 1px 1px 15px -5px $black;
	opacity: 0;
	visibility: hidden;
	transition: $dur $ease;
	pointer-events: none;
	font-size: 14px;
	display: block;
	font-family: $font-main;
	word-break: break-all;
	line-height: 1.2;
	color: $fiord;

	@include mq($sm) {
		font-size: 13px;
	}
}

.arrow-angle {
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 8px 11px 10px;
	border-color: transparent transparent #fff transparent;
	bottom: -8px;
	position: absolute;
	left: 17px;
	transform: rotateX(187deg) translateX(-50%);
	box-shadow: 1px 1px 15px -5px #000;
	z-index: 8;
}

.error-messages__list {
	margin: -25px auto 20px;

	@include mq($xl) {
		margin: -10px auto 20px;
	}

	@include mq($lg) {
		margin: 0 auto 20px;
	}
}

.btn--pdf--upload {
	@include mq(500px) {
		max-width: 100%;
	}
}
</style>
